import type { CoverData, TargetLanguageCode } from '@ellie/shared';

interface BackCoverProps {
  coverData: CoverData;
  targetLanguage?: TargetLanguageCode;
}

export function BackCover({ coverData, targetLanguage }: BackCoverProps) {
  return (
    <div
      className="wb-page wb-back-cover"
      data-language={targetLanguage ?? coverData.targetLanguageCode}
    >
      <div className="wb-logo-text">Ellie</div>
      <p className="wb-tagline">
        Your personal language workbook. New every month, tailored just for you.
      </p>
      <div className="wb-cta-box">
        <div className="wb-cta-label">Order more workbooks?</div>
        <div className="wb-cta-url">ellie-workbooks.com</div>
      </div>
      <p
        style={{
          fontSize: '0.85rem',
          opacity: 0.6,
          maxWidth: '340px',
          lineHeight: 1.6,
        }}
      >
        This workbook was made for <strong>{coverData.displayName}</strong>.
        <br />
        Level {coverData.level} &middot; {coverData.nativeLanguageName} &rarr;{' '}
        {coverData.targetLanguageName}
        <br />
        Edition {coverData.month} {coverData.year}
      </p>
      <div className="wb-footer-meta">
        &copy; {coverData.year} Language Enabler V.O.F. &middot; All rights reserved
      </div>
    </div>
  );
}
